import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useLayoutEffect, useMemo, useState } from 'react';
import { Text, View, Image, ScrollView, Pressable, Animated, Easing, Dimensions } from 'react-native';
import { Title } from '../../Title/rn';
import { Button } from '../../Button/rn';
import { ButtonGroup } from '../../ButtonGroup/rn';
import closeImage from '../../../assets/images/close.png'; // import prevImage from '../../../assets/images/prev.png';

import PrevArrow from '../../Image/rn/PrevArrow';
import { useLocale } from '../../LocaleProvider/rn';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { DefaultModalZIndex } from '../../../constants/common';
import { MODAL_CLOSE_TEXT } from '../../../utils/constants';
import * as RNStyle from '../../../styles/rn';
import Portal from './portal';
import Delayed from '../../Delayed/rn';
import ModalKeyboardAvoidingView from './ModalKeyboardAvoidingView';
import { CustomStyleSheet } from '../../../utils/rn/tools';
var screenHeight = Dimensions.get('window').height;
export var Base = function Base(props) {
  var active = props.active,
    _props$renderByShow = props.renderByShow,
    renderByShow = _props$renderByShow === void 0 ? false : _props$renderByShow;
  var context = useContext(ConfigContext); // const handleHardwareBackPress = () => {
  //   props.onClose();
  //   return true;
  // };

  useLayoutEffect(function () {
    var _context$eventEmitter;
    if (active) {
      var _context$increaseModa;
      context === null || context === void 0 ? void 0 : (_context$increaseModa = context.increaseModalZIndex) === null || _context$increaseModa === void 0 ? void 0 : _context$increaseModa.call(context);
    }
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.emit('setGlobalModalConfigVisible', active);
    return function () {
      var _context$eventEmitter2;

      // 这里的使用 逻辑 都是 当 visible 变量 为 false 时 返回 null 所以这里监听不到 active 等于 false 的情况
      // 为了解决这个问题 添加逻辑在组件销毁的时候 手动赋值为 false
      context === null || context === void 0 ? void 0 : (_context$eventEmitter2 = context.eventEmitter) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.emit('setGlobalModalConfigVisible', false);
    };
  }, [active]);
  useLayoutEffect(function () {
    if (active) {
      var _context$eventEmitter3;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : _context$eventEmitter3.emit('setGlobalModalConfigHide', function () {
        var _props$onClose;

        // TODO: 在实际调用时，此处onClose可能取不到，先做兜底处理，后续@xingwei@xinsen看看
        props === null || props === void 0 ? void 0 : (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
      });
    }
  }, [props.onClose]); // !!! 组件不处理返回自动关闭逻辑
  // useEffect(() => {
  //   BackHandler.addEventListener('hardwareBackPress', handleHardwareBackPress);
  //   return () => {
  //     BackHandler.removeEventListener('hardwareBackPress', handleHardwareBackPress);
  //   };
  // }, []);

  if (renderByShow) {
    return /*#__PURE__*/React.createElement(BaseContainer, props);
  }
  return active ? /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(BaseContainer, props)) : null;
};
var DELAY_TIME = 200;
export var BaseContainer = function BaseContainer(props) {
  var title = props.title,
    _props$titlePosition = props.titlePosition,
    titlePosition = _props$titlePosition === void 0 ? 'left' : _props$titlePosition,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
    _props$showCloseIcon = props.showCloseIcon,
    showCloseIcon = _props$showCloseIcon === void 0 ? false : _props$showCloseIcon,
    _props$showPrevIcon = props.showPrevIcon,
    showPrevIcon = _props$showPrevIcon === void 0 ? false : _props$showPrevIcon,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? false : _props$showCloseButto,
    _props$showMask = props.showMask,
    showMask = _props$showMask === void 0 ? true : _props$showMask,
    closeButtonText = props.closeButtonText,
    type = props.type,
    titleStyle = props.titleStyle,
    titleContainerStyle = props.titleContainerStyle,
    contentStyle = props.contentStyle,
    contentContainerStyle = props.contentContainerStyle,
    children = props.children,
    closeWhenClickOutside = props.closeWhenClickOutside,
    _props$showBoxShadow = props.showBoxShadow,
    showBoxShadow = _props$showBoxShadow === void 0 ? false : _props$showBoxShadow,
    _props$modalContainer = props.modalContainerStyle,
    modalContainerStyle = _props$modalContainer === void 0 ? {} : _props$modalContainer,
    _props$haveContentScr = props.haveContentScrollbar,
    haveContentScrollbar = _props$haveContentScr === void 0 ? false : _props$haveContentScr,
    _props$maskContainerS = props.maskContainerStyle,
    maskContainerStyle = _props$maskContainerS === void 0 ? {} : _props$maskContainerS,
    _props$contentScrolla = props.contentScrollable,
    contentScrollable = _props$contentScrolla === void 0 ? true : _props$contentScrolla,
    delayBeforeContentShow = props.delayBeforeContentShow,
    useKeyboardAvoidingView = props.useKeyboardAvoidingView,
    onTrackChange = props.onTrackChange;
  var context = useContext(ConfigContext);
  var zIndex = props.zIndex || context.modalZIndex || DefaultModalZIndex;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    maskVisible = _useState2[0],
    setMaskVisible = _useState2[1];
  var onClickOutside = function onClickOutside(e) {
    var _e$stopPropagation;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
    if (showMask) {
      var _props$onMaskClick;
      (_props$onMaskClick = props.onMaskClick) === null || _props$onMaskClick === void 0 ? void 0 : _props$onMaskClick.call(props);
      if (maskClosable) {
        props.onClose(e);
      }
    } else if (closeWhenClickOutside) {
      props.onClose(e);
    }
  };
  useLayoutEffect(function () {
    setTimeout(function () {
      setMaskVisible(true);
    }, type === 'popup' ? DELAY_TIME : 0);
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.modal, {
      zIndex: zIndex
    }, maskVisible && showMask && [styles['modal-mask'], maskContainerStyle], modalContainerStyle]
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: onClickOutside,
    style: [styles.modal, type === 'modal' && {
      alignItems: 'center',
      justifyContent: 'center'
    }]
  }, /*#__PURE__*/React.createElement(ModalKeyboardAvoidingView, {
    useKeyboardAvoidingView: useKeyboardAvoidingView
  }, /*#__PURE__*/React.createElement(BaseContent, {
    title: title,
    titlePosition: titlePosition,
    type: type,
    showCloseIcon: showCloseIcon,
    showPrevIcon: showPrevIcon,
    showCloseButton: showCloseButton,
    footer: props.footer,
    closeButtonText: closeButtonText,
    titleStyle: titleStyle,
    titleContainerStyle: titleContainerStyle,
    contentStyle: contentStyle,
    styles: contentContainerStyle,
    closeWhenClickOutside: closeWhenClickOutside,
    onClose: props.onClose,
    onPrev: props.onPrev,
    showBoxShadow: showBoxShadow,
    haveContentScrollbar: haveContentScrollbar,
    contentScrollable: contentScrollable,
    delayBeforeContentShow: delayBeforeContentShow,
    onTrackChange: onTrackChange
  }, children))));
};
export var BaseContent = function BaseContent(props) {
  var title = props.title,
    titlePosition = props.titlePosition,
    type = props.type,
    showCloseIcon = props.showCloseIcon,
    showPrevIcon = props.showPrevIcon,
    showCloseButton = props.showCloseButton,
    closeButtonText = props.closeButtonText,
    titleStyle = props.titleStyle,
    titleContainerStyle = props.titleContainerStyle,
    contentStyle = props.contentStyle,
    stylesProps = props.styles,
    children = props.children,
    showBoxShadow = props.showBoxShadow,
    haveContentScrollbar = props.haveContentScrollbar,
    contentScrollable = props.contentScrollable,
    delayBeforeContentShow = props.delayBeforeContentShow,
    onPrev = props.onPrev,
    onClose = props.onClose,
    onTrackChange = props.onTrackChange;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var popUpAndScrollbar = haveContentScrollbar && type === 'modal';
  var ModalContent = useMemo(function () {
    var childrenEle = typeof children === 'string' ? /*#__PURE__*/React.createElement(Text, {
      style: styles['modal-modal-content-text']
    }, children) : children;
    return contentScrollable ? /*#__PURE__*/React.createElement(ScrollView, {
      showsVerticalScrollIndicator: popUpAndScrollbar,
      onLayout: function onLayout() {
        onTrackChange === null || onTrackChange === void 0 ? void 0 : onTrackChange();
      },
      scrollEventThrottle: 16,
      onScroll: function onScroll() {
        onTrackChange === null || onTrackChange === void 0 ? void 0 : onTrackChange();
      },
      overScrollMode: "never"
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles["modal-".concat(type, "-content")], contentStyle],
      onStartShouldSetResponder: function onStartShouldSetResponder() {
        return true;
      }
    }, childrenEle)) : /*#__PURE__*/React.createElement(View, {
      style: [styles["modal-".concat(type, "-content")], contentStyle],
      onLayout: function onLayout() {
        onTrackChange === null || onTrackChange === void 0 ? void 0 : onTrackChange();
      }
    }, childrenEle);
  }, [popUpAndScrollbar, type, contentStyle, children]);
  var animatedValue = React.useRef(new Animated.Value(0));
  var bottom = animatedValue.current.interpolate({
    inputRange: [0, 1],
    outputRange: [-screenHeight * 0.8, 0]
  });
  useLayoutEffect(function () {
    Animated.timing(animatedValue.current, {
      toValue: 1,
      delay: DELAY_TIME,
      duration: 300,
      // Accelerate then decelerate - https://cubic-bezier.com/#.28,0,.63,1
      easing: Easing.linear,
      useNativeDriver: false // 'bottom' is not supported by native animated module
    }).start();
  }, []);
  return /*#__PURE__*/React.createElement(Animated.View, {
    style: [styles["modal-".concat(type)], stylesProps, showBoxShadow && styles['modal-shadow'], type === 'popup' && {
      bottom: bottom
    }] // catch the event propagated and stop it
    ,

    onStartShouldSetResponder: function onStartShouldSetResponder() {
      return true;
    },
    onTouchEnd: function onTouchEnd(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.isValidElement(title) ? title : /*#__PURE__*/React.createElement(React.Fragment, null, showPrevIcon ? /*#__PURE__*/React.createElement(Pressable, {
    style: styles["modal-".concat(type, "-prev")],
    onPress: onPrev
  }, /*#__PURE__*/React.createElement(PrevArrow, {
    style: {
      width: 24,
      height: 24
    }
  })) : null, showCloseIcon ? /*#__PURE__*/React.createElement(Pressable, {
    style: styles["modal-".concat(type, "-close")],
    onPress: onClose
  }, /*#__PURE__*/React.createElement(Image, {
    source: closeImage,
    style: {
      width: '100%',
      height: '100%'
    }
  })) : null, title ? /*#__PURE__*/React.createElement(View, {
    style: [type === 'popup' && styles['modal-popup-border-bottom'], titleContainerStyle]
  }, /*#__PURE__*/React.createElement(Title, {
    styles: [styles[titlePosition === 'center' ? "modal-".concat(type, "-center-title") : "modal-".concat(type, "-title")], titleStyle],
    content: title,
    maxLines: 5
  })) : null), delayBeforeContentShow ? /*#__PURE__*/React.createElement(Delayed, {
    waitBeforeShow: delayBeforeContentShow
  }, ModalContent) : ModalContent, props.footer ? /*#__PURE__*/React.createElement(ButtonGroup, props.footer) : showCloseButton ? /*#__PURE__*/React.createElement(View, {
    style: styles["modal-".concat(type, "-footer")]
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    text: closeButtonText || trans(MODAL_CLOSE_TEXT),
    styles: {
      textStyle: styles['modal-close-button-text'],
      containerStyle: styles['modal-close-button-container']
    },
    onClick: onClose
  })) : null);
};
var stylesheets = CustomStyleSheet({
  // position: absolute;
  // width: 100%;
  // height: 100%;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 0;
  // overflow: hidden;
  modal: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  // &-shadow {
  //   box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.04);
  // }
  'modal-shadow': {
    shadowOffset: {
      width: 0,
      height: 0
    },
    shadowRadius: 16,
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    elevation: 1
  },
  // background: @mask-bg;
  // opacity: 0.3;
  'modal-mask': {
    backgroundColor: RNStyle.mask_bg_gray
  },
  'modal-popup': {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    width: '100%',
    maxHeight: screenHeight * 0.8,
    backgroundColor: RNStyle.white,
    zIndex: RNStyle.zindex_modal_content,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    bottom: '-100%'
  },
  'modal-popup-close': {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 20,
    height: 20,
    zIndex: 1
  },
  'modal-popup-prev': {
    position: 'absolute',
    top: 12,
    left: 12,
    width: 20,
    height: 20,
    zIndex: 1
  },
  'modal-popup-title': {
    padding: 12,
    flexShrink: 0
  },
  'modal-popup-center-title': {
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 40,
    paddingRight: 40,
    textAlign: 'center',
    alignSelf: 'center',
    flexShrink: 0
  },
  'modal-popup-border-bottom': {
    borderBottomWidth: 0.5,
    borderStyle: 'solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.09)'
  },
  // &-content {
  //   height: 100%;

  /**
   * 使用scrollView
   */
  //   overflow-y: auto;
  //   overflow-x: hidden;
  //   padding: 0.75 rem;
  // }
  'modal-popup-content': {
    flex: 1,
    padding: 12
  },
  // &-footer {
  //   height: 3.625rem;
  // }
  'modal-popup-footer': {
    height: 58
  },
  // .@{prefix-cls}-modal-close-button {
  //   padding: 0;
  //   height: 2.625rem;
  //   line-height: 2.625rem;
  //   font-size: 1rem;
  //   margin: 0.5rem;
  // }
  'modal-close-button-container': {
    padding: 0,
    height: 42,
    margin: 8,
    flexGrow: 0,
    justifyContent: 'center',
    alignItems: 'center'
  },
  'modal-close-button-text': {
    fontSize: 16
  },
  /**
   * type=modal，容器设置元素居中
   */
  // & > &-modal {
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  // }
  // &-modal {
  //   display: flex;
  //   flex-direction: column;
  //   max-width: 100%;
  //   width: 19.0625rem;
  //   max-height: 80%;
  //   /* bottom: 0; */
  //   background: @white;
  //   z-index: @zindex-modal-content;
  //   border-radius: 0.25rem;
  'modal-modal': {
    flexDirection: 'column',
    maxWidth: '100%',
    width: 305,
    maxHeight: '80%',
    backgroundColor: RNStyle.white,
    borderRadius: 4
  },
  // &-close {
  //   position: absolute;
  //   top: 0.75rem;
  //   right: 0.75rem;
  //   width: 1.25rem;
  //   height: 1.25rem;
  //   cursor: pointer;

  /**
   * 设置为行内样式
   */
  //   img {
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
  'modal-modal-close': {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 20,
    height: 20,
    zIndex: 1
  },
  // &-title {
  //   padding: 1.25rem 1.25rem 0;
  //   font-style: normal;
  //   font-weight: 500;
  //   font-size: 1rem;
  //   line-height: 1.25rem;
  //   color: @gray-1;
  //   text-align: center;
  // }
  'modal-modal-title': _objectSpread(_objectSpread({
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 0,
    fontStyle: 'normal'
  }, RNStyle.FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 16,
    lineHeight: 20,
    color: RNStyle.gray_1,
    textAlign: 'center'
  }),
  // .modal-modal-content() {
  //   padding: 0 1.25rem 1.25rem;
  //   margin-top: 1rem;
  //   font-size: 0.875rem;
  //   color: @gray-2;
  //   overflow: auto;
  // }
  // &-content {
  //   .modal-modal-content();
  //   &::-webkit-scrollbar {
  //     display: none;
  //   }
  // }
  'modal-modal-content': {
    paddingTop: 0,
    paddingHorizontal: 20,
    paddingBottom: 24,
    marginTop: 16
  },
  /**
   * 使用scrollView属性进行设置
   */
  // &-have-scrollbar-content {
  //   .modal-modal-content();
  // }
  'modal-modal-content-text': {
    fontSize: 14,
    color: RNStyle.gray_2
  }
});
var styles = stylesheets;